import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ChallengeTypeOptions from "data/Challenge/ChallengeType.json";

const ChallengeTypeModal = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleCardClick = (value) => {
    history.push(`/admin/challenges/jobinformation?type=${value}`);
  };

  return (
    <div
      className="modal fade"
      id="challengeTypeModal"
      tabIndex="-1"
      aria-labelledby="challengeTypeModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content rounded-10 border-0 shadow">
          <div className="modal-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  category
                </span>
              </div>
              <div>
                <h3
                  className="offcanvas-title fw-bold text-white mb-0"
                  id="challengeTypeModalLabel"
                >
                  {t("Select Challenge Type")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Choose the type of challenge to create")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body py-5">
            <div
              className={`row g-4 ${
                ChallengeTypeOptions.length === 2
                  ? "justify-content-center"
                  : ""
              }`}
            >
              {ChallengeTypeOptions.map((option, index) => (
                <div className="col-md-6 col-lg-6 col-xl-3" key={index}>
                  <div
                    className="card challenge-type-card h-100 border rounded-10 shadow-sm cursor-pointer hover-effect"
                    onClick={() => handleCardClick(option.value)}
                    data-bs-dismiss="modal"
                  >
                    <div className="card-body text-center p-4">
                      <div className="icon-container mb-3">
                        <span className="material-symbols-outlined icon-lg">
                          {option.value === "talenthunt"
                            ? "group"
                            : option.value === "capitalquest"
                            ? "savings"
                            : option.value === "supplybid"
                            ? "inventory_2"
                            : "category"}
                        </span>
                      </div>
                      <h3 className="fs-md fw-semibold mb-2">{option.label}</h3>
                      <p className="fs-sm mb-0">
                        {option.value === "talenthunt"
                          ? t("Find the perfect talent")
                          : option.value === "capitalquest"
                          ? t("Find capital and investors")
                          : option.value === "supplybid"
                          ? t("Get supply chain bids")
                          : t("New challenge opportunity")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeTypeModal;
